import Commons from './Common';
import Global from './Global';

const CLIENT_PLATFORM_WEB = 'WEB';

/** v.1.3.0 / v1.3.0 / 1.3.0 → v.1.3.0 (DB 표준) */
export const NormalizeClientVersion = (version) => {
  const trimmed = String(version ?? '').trim();
  if (!trimmed) return '';

  const numeric = trimmed.replace(/^v\.?/i, '');
  if (!numeric) return trimmed;

  return `v.${numeric}`;
};

export const IsClientVersionOutdated = (current, latest) => {
  const normalizedCurrent = NormalizeClientVersion(current);
  const normalizedLatest = NormalizeClientVersion(latest);
  if (!normalizedLatest) return false;
  return normalizedCurrent !== normalizedLatest;
};

const GetBundledClientVersion = async () => {
  try {
    const res = await fetch('/version.json', { cache: 'no-store' });
    const data = await res.json();
    return data?.version ?? '';
  } catch {
    return '';
  }
};

export const BuildCheckClientVersionPayload = async () => {
  const bundledVersion = (await GetBundledClientVersion()) || 'v.0.0.0';
  return {
    Platform: CLIENT_PLATFORM_WEB,
    CurrentVersion: NormalizeClientVersion(bundledVersion) || bundledVersion,
  };
};

export const RequestCheckClientVersion = async (axiosType = 'post') => {
  const payload = await BuildCheckClientVersionPayload();
  const result = await Commons.Axios(
    axiosType,
    Global.base.useUrl + Global.urls.Account.CheckClientVersion,
    payload
  );
  return result?.data;
};

export const ParseCheckClientVersionResponse = (data) => {
  const row = data?.Data?.[0] ?? data?.data?.[0] ?? null;
  if (!row) return null;

  return {
    latestVersion: NormalizeClientVersion(row.LatestVersion ?? row.latestVersion ?? ''),
    currentVersion: NormalizeClientVersion(row.CurrentVersion ?? row.currentVersion ?? ''),
    forceUpdate: Boolean(row.ForceUpdate ?? row.forceUpdate),
  };
};

export const ToManagerVersionRows = (parsed) => {
  if (!parsed?.latestVersion) return [];
  return [{ type: 'MANAGER', version: parsed.latestVersion }];
};
